import React from 'react';
import { useIsMobile } from '@guildeducationinc/catalog-tools';
import {
	AcademicPartnerContentItemCategory,
	GetMemberProgramQuery,
} from 'src/graphqlTypes/catalogServiceTypes';
import { Typography } from '@guildeducationinc/recess';
import { ApplicationSteps } from 'src/components/ProgramDetails/Applications/ApplicationSteps';
import { HowToPrepare } from 'src/components/ProgramDetails/Applications/HowToPrepare';
import { Skeleton } from 'src/components/UserFacetSkeletonLoader';
import styles from './Applications.module.scss';

interface Props {
	program: GetMemberProgramQuery['memberProgram'];
	loading: boolean;
}

export const Applications: React.FC<Props> = ({ program, loading }) => {
	const isMobile = useIsMobile();

	const hasSteps = program?.studentFacingAcademicPartner.contentItems.some(
		item => item.category === AcademicPartnerContentItemCategory.APPLICATION_STEP
	);
	const hasPreps = program?.studentFacingAcademicPartner.contentItems.some(
		item => item.category === AcademicPartnerContentItemCategory.APPLICATION_PREP
	);

	if (!hasSteps && !hasPreps) {
		return null;
	}

	return (
		<section
			aria-label='applications'
			className={styles.sectionContainer}
			data-testid='program-detail-application'
			data-title='Ready to start?'
			id='detail-start'
			tabIndex={-1}
		>
			<div className={styles.wrapper}>
				<Typography className={isMobile ? styles.titleMobile : styles.title} variant='h2'>
					Ready to start?
				</Typography>
				<Typography variant={isMobile ? 'body1' : 'body2'}>
					You&apos;re just a few steps away from starting your new career path. We&apos;ll walk you
					through it.
				</Typography>
			</div>
			<Skeleton count={2} dataLoading={loading} height={64}>
				<ApplicationSteps program={program} />
				<HowToPrepare program={program} />
			</Skeleton>
		</section>
	);
};
